import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Price root layout using HEN Design System tokens.
 * Typography scale is owned by the `size` → Text `variant` map in `Price.tsx`.
 */
export const priceVariants = cva('inline-flex items-baseline gap-xs');

export type PriceVariantProps = VariantProps<typeof priceVariants>;
